"use strict";

define('rs/models/meeting.document',['rs/models/abstract', 'rs/models/document'], function (RSAbstractModel, Document) {
  var MeetingDocument = RSAbstractModel.extend({
    properties: ['meeting', 'document'],
    serverProperties: ['activityDate', 'notes', 'updateUserAuthId', 'version'],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      if (!this.getDocument()) {
        throw new Error('You Cannot create a MeetingDocument without a Document.');
      }
      if (!(this.getDocument() instanceof Document)) {
        this.setDocument(Document.model(this.getDocument()));
      }
      if (!(this.getMeeting() instanceof MeetingDocument.Meeting)) {
        this.setMeeting(MeetingDocument.Meeting.model(this.getMeeting()));
      }
    },
    getDocumentId: function getDocumentId() {
      var doc = this.getDocument();
      return doc ? doc.id : null;
    },
    getMeetingId: function getMeetingId() {
      var meeting = this.getMeeting();
      return meeting ? meeting.id : null;
    },
    requestUpdate: function requestUpdate() {
      var that = this;
      return this.constructor.requestUpdate(this.getMeetingId(), this.getDocumentId(), this).then(function (data) {
        that.trigger('sync');
        that.updateWithServerProperties(data);
        return that;
      });
    },
    requestAllNotes: function requestAllNotes() {
      var documentId = this.getDocumentId(),
        meetingId = this.getMeetingId();
      return MeetingDocument.Meeting.requestNotes(documentId).then(function (notes) {
        return _.reject(notes, function (note) {
          return note.meeting ? note.meeting.id == meetingId : false;
        });
      });
    },
    toJSON: function toJSON() {
      var json = this._super.apply(this, arguments);
      json.document = {
        id: this.getDocumentId()
      };
      return json;
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#GET#meetingDocument/:id/:id': function GETMeetingDocument_Id_Id(data) {
        return this.model(data);
      }
    },
    requestOne: function requestOne(meetingId, documentId) {
      return this.get('meetingDocument/' + meetingId + '/' + documentId);
    },
    requestUpdate: function requestUpdate(meetingId, documentId, data) {
      return this.put('meetingDocument/' + meetingId + '/' + documentId, data, {
        jsonBody: true
      });
    }
  });
  return MeetingDocument;
});

